export const alertTypes = {
    SUCCESS: 'toast_success',
    ERROR: 'toast_error',
    CLEAR: 'toast_clear'
};

export const authTypes = {
    LOGIN_SUCCESS: 'login_success',
    LOGIN_FAILURE: 'login_failure',
    REGISTER_SUCCESS: 'register_success',
    REGISTER_FAILURE: 'register_failure',
    RESET_SENT_SUCCESS: 'reset_sent_success',
    RESET_SENT_FAILURE: 'reset_sent_failure',
    RESET_PASSWORD_SUCCESS: 'reset_password_success',
    RESET_PASSWORD_FAILURE: 'reset_password_failure'
};

export const gameTypes = {
    FETCH_GAMES: 'fetch_games',
    CREATE_GAME_REQUEST: 'create_game_request',
    CREATE_GAME_SUCCESS: 'create_game_success',
    CREATE_GAME_FAILURE: 'create_game_failure',
    EDIT_GAME_REQUEST: 'edit_game_request',
    EDIT_GAME_SUCCESS: 'edit_game_success',
    EDIT_GAME_FAILURE: 'edit_game_failure',
    DELETE_GAME_SUCCESS: 'delete_game_success',
    DELETE_GAME_FAILURE: 'delete_game_failure'
};

export const playerTypes = {
    ADD_PLAYER_SUCCESS: 'add_player_success',
    ADD_PLAYER_FAILURE: 'add_player_failure',
    REMOVE_PLAYER_SUCCESS: 'remove_player_success',
    REMOVE_PLAYER_FAILURE: 'remove_player_failure',
    FETCH_PLAYERS: 'fetch_players',
    FETCH_PLAYERS_FAILURE: 'fetch_players_failure',
    EDIT_PLAYER_TEAM_SUCCESS: 'edit_player_team_success',
    EDIT_PLAYER_TEAM_FAILURE: 'edit_player_team_failure'
};

export const userTypes = {
    FETCH_USER: 'fetch_user',
    UPDATE_CREDITS: 'update_credits',
    UPDATE_NOTIFICATIONS: 'update_notifications',
    EDIT_USER_SUCCESS: 'edit_user_success,',
    EDIT_USER_FAILURE: 'edit_user_failure,'
};

export const notificationTypes = {
    FETCH_NOTIFICATIONS: 'fetch_notifications'
}


// WEBPACK FOOTER //
// ./src/actions/_actionTypes.js